export type ScriptInstructions = Array<InstructionType>;

export type InstructionType =
  ImageInstruction
  | TextInstruction
  | NoteInstruction
  | VideoInstruction
  | TitleInstruction
  | NameScriptInstruction
  | WebPageInstruction
  | DocumentPageInstruction
  | AudioInstruction;

type BaseInstruction<T extends InstructionTypes> = {
  id: string;
  type: T;
  comment: string;
  needsInfo: boolean;
};

export type ImageInstruction = BaseInstruction<InstructionTypes.imageInstruction> & {
  data: {
    documentId: number;
    imageEffect: number;
    screenLocation: number;
  };
};

export type TextInstruction = BaseInstruction<InstructionTypes.textInstruction> & {
  data: {
    text: string;
    screenLocation: number;
  };
};

export type NoteInstruction = BaseInstruction<InstructionTypes.noteInstruction> & {
  data: {
    url: string;
  };
};

export type VideoInstruction = BaseInstruction<InstructionTypes.videoInstruction> & {
  data: {
    screenLocation: number;
    duration: number;
    startTime: number;
    videoId: number;
  };
};

export type TitleInstruction = BaseInstruction<InstructionTypes.titleInstruction> & {
  data: {
    presenter: number;
  };
};

export type NameScriptInstruction = BaseInstruction<InstructionTypes.nameScriptInstruction> & {
  data: {
    name: number;
  };
};

export type WebPageInstruction = BaseInstruction<InstructionTypes.webPageInstruction> & {
  data: {
    link: string;
  };
};

export type DocumentPageInstruction = BaseInstruction<InstructionTypes.documentInstruction> & {
  data: {
    documentId: number;
    page: number;
    screenLocation: number;
  };
};

export type AudioInstruction = BaseInstruction<InstructionTypes.audioInstruction> & {
  data: {
    documentId: number;
    level: number;
    duration: number;
  };
};

/**
* ATTENTION do not change names, otherwise the existing instructions will not work
**/
export enum EditorToolInstructionTypes {
  video = 'videoInstruction',
  videoBlock = 'videoInstructionBlock',
  audio = 'audioInstruction',
  audioBlock = 'audioInstructionBlock',
  image = 'imageInstruction',
  imageBlock = 'imageInstructionBlock',
  text = 'textInstruction',
  textBlock = 'textInstructionBlock',
  title = 'titleInstruction',
  titleBlock = 'titleInstructionBlock',
  note = 'noteInstruction',
  noteBlock = 'noteInstructionBlock',
  nameScript = 'nameScriptInstruction',
  nameScriptBlock = 'nameScriptInstructionBlock',
  document = 'documentInstruction',
  documentBlock = 'documentInstructionBlock',
  webPage = 'webPageInstruction',
  webPageBlock = 'webPageInstructionBlock',
}
/**
 * ATTENTION do not change names, otherwise the existing instructions will not work
 **/
export enum InstructionTypes {
  videoInstruction = 'video',
  audioInstruction = 'audio',
  imageInstruction = 'image',
  textInstruction = 'text',
  titleInstruction = 'title',
  noteInstruction = 'note',
  nameScriptInstruction = 'nameScript',
  documentInstruction = 'documentPage',
  webPageInstruction = 'webPage',
}
